import { render, staticRenderFns } from "./order_status.vue?vue&type=template&id=8265d20a&scoped=true&"
import script from "./order_status.vue?vue&type=script&lang=js&"
export * from "./order_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265d20a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8265d20a')) {
      api.createRecord('8265d20a', component.options)
    } else {
      api.reload('8265d20a', component.options)
    }
    module.hot.accept("./order_status.vue?vue&type=template&id=8265d20a&scoped=true&", function () {
      api.rerender('8265d20a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/order_status.vue"
export default component.exports